
import { defineComponent } from 'vue'
import Badge from 'primevue/badge'

export default defineComponent({
    name: 'kn-tab-card',
    components: { Badge },
    props: {
        badge: null,
        element: {},
        selected: Boolean
    }
})
